export default {
	documents: {
		previewError: {
			line1: 'Unfortunately, the preview could not be displayed.',
			line2: 'Please open or save the document!',
		},
		relatedFiles: 'Files related to the document',
		noFilesInContainer: 'No files have been found in the document containers.',
		noFilesMatchSearch: 'No files match your search',
		downloadAll: 'Download all',
		download: 'Download',
		selectAll: '@:common.selectAll',
		deselectAll: 'Deselect all',
		clearSelection: 'Clear selection',
		selectedBar: '{count} file selected | {count} files selected',
		attachments: 'Attachments',
		searchPlaceholder: 'Search files...',
		sortBy: 'Sort by',
		perPage: 'Per page',
		showing: 'Showing',
		of: 'of',
		groups: 'Groups',
		folders: 'Folders',
		files: 'Files',
		noFolder: 'No folder',
		noDocumentType: 'No document type',
		selectedOf: '{count} of {total} files selected',
		downloadZip: 'Download {count} file (ZIP) | Download {count} files (ZIP)',
		downloadFolder: 'Download folder (ZIP)',
		hiddenNoMatch:
			'{count} file without match hidden | {count} files without match hidden',
		showAll: 'show all',
		noMatch: 'no match',
		matchCount: '{count} matches',
		journalCount: '{count} booking | {count} bookings',
		toJournal: 'Go to booking',
		fileAndDocument: 'File · document',
		fileHandling: {
			removeFile: 'Remove file',
			containerName: 'Label',
			fileName: 'File name',
			addFiles: 'Add files',
			addContainer: 'Another document',
			removeContainer: 'Remove document',
			willBeDeleted: 'will be deleted',
			willBeDetached: 'will be unlinked',
		},
		containerDialog: {
			documentCount: 'Documents',
			newDocument: 'Create new document',
			unnamedDocument: 'Without label',
			dropNew: 'Drop files here → new document',
			dropMore: 'Drop more files into this document or',
			chooseFiles: 'choose',
			typeForAll: 'Type for all files',
			typeForAllSet:
				'Document type "{type}" set for all files of this document',
			moreActions: 'More actions',
			detach: 'Unlink',
			detachHint: 'Removes the document here only — it stays in {target}',
			detachHintGeneric: 'Removes the document here only — it stays elsewhere',
			delete: 'Delete',
			deleteHint: 'Deletes the document with all its files everywhere',
			discard: 'Discard',
			discardHint: 'Remove the new document again',
			undoMark: 'Undo mark',
			markedForDetach: 'Will be unlinked on save — stays in {target}.',
			markedForDetachGeneric: 'Will be unlinked on save — stays elsewhere.',
			markedForDelete: 'Will be deleted on save — with all files, everywhere.',
			fileMarkedForDelete: 'will be deleted on save',
			isNew: 'new',
			suggestion: 'Suggestion — applied on save',
			missingType: 'Document type missing',
			missingTypeCount:
				'{count} document type missing | {count} document types missing',
			fileCount: '{count} file | {count} files',
			countNew: 'new',
			countDelete: 'to delete',
			countDetach: 'to unlink',
			countChanged: 'changed',
			saveChanges: 'Save {count} change | Save {count} changes',
			noDocuments:
				'No document yet — create one with the plus on the left or drop files.',
			noDocumentsReadonly: 'No attachments are stored for this review.',
			documentPosition: 'Attachments · document {index} of {total}',
			renameFile: 'Click to rename',
			deleteFile: 'Delete on save',
			removeFile: 'Remove file',
			undoDelete: 'Undo delete',
			openPreview: 'Open preview',
			viewMode: 'View attachments',
			manageMode: 'Manage attachments',
			unsavedInView:
				'You have unsaved changes. This view shows the saved state — switch back to management to save.',
			previewUnavailable: 'The preview is available after saving.',
			modeManage: 'Manage',
			modeView: 'View',
			noChanges: 'No pending changes',
			filesSection: 'Files',
			filesWithTypeAll: 'all with document type',
			filesWithType: '{done} / {total} with type',
			missingTypeShort: '{count} without type',
			missingName: 'Label missing',
			missingNameCount:
				'Label missing on {count} document | Label missing on {count} documents',
			journalCount: '{count} booking | {count} bookings',
			noJournal: 'no booking',
			fileCountChange: '{from} → {to} files',
			filesMarkedForDelete:
				'{count} file will be deleted | {count} files will be deleted',
			typeForAllApplied: 'Applied to {count} file | Applied to {count} files',
			summary:
				'{docs} documents · {files} files · {assigned} assigned to a booking',
		},
		dropzone: {
			title: 'Drop files here to upload',
			hint: 'Allowed: {types} — max. {maxSize} MB per file',
		},
		view: {
			list: 'List view',
			container: 'Folder view',
			grouped: 'Document types',
		},
		tooltip: {
			list: 'List view',
			container: 'Folder view',
			grouped: 'Document type view',
		},
		filter: {
			type: 'Document type',
			reset: 'Reset',
			count: '{count} of {total} files',
		},
		column: {
			file: 'File',
			type: 'Document type',
			folder: 'Folder',
			size: 'Size',
			date: 'Date',
		},
		sort: {
			typeAsc: 'Document type: A-Z',
			typeDesc: 'Document type: Z-A',
			createdDesc: 'Newest first',
			createdAsc: 'Oldest first',
			nameAsc: 'Name: A-Z',
			nameDesc: 'Name: Z-A',
		},
	},
}
